const STORAGE_KEY = 'nt7east:wishlist';

/**
 * Reads the wishlist product id list from localStorage.
 * @returns {string[]}
 */
function readWishlist() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

/**
 * Persists the wishlist product id list to localStorage.
 * @param {string[]} ids
 */
function writeWishlist(ids) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch (error) {
    // Ignore storage errors (private browsing, storage disabled, etc).
  }
}

/**
 * A small custom element that lets a shopper mark a cart line's product as a
 * favorite. State is stored client-side only (localStorage), scoped per
 * browser, with no backend/app dependency.
 */
class CartWishlistButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.productId = this.dataset.productId;
    this.updateState();

    this.button.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  handleClick = () => {
    if (!this.productId) return;

    const ids = readWishlist();
    const index = ids.indexOf(this.productId);

    if (index === -1) {
      ids.push(this.productId);
    } else {
      ids.splice(index, 1);
    }

    writeWishlist(ids);
    this.updateState();
  };

  updateState() {
    if (!this.button || !this.productId) return;

    const isSaved = readWishlist().includes(this.productId);
    this.button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
  }
}

if (!customElements.get('cart-wishlist-button')) {
  customElements.define('cart-wishlist-button', CartWishlistButton);
}
